
import { useState, useEffect } from 'react';
import { getUserLocationFromIP } from '@/utils/geo-location';
import { getDefaultCurrencyForCountry } from '@/utils/currency-data';

export interface UserLocation {
  country: string | null;
  region: string | null;
  city: string | null;
  currency: string | null;
}

export const useLocationHandling = () => {
  const [userLocation, setUserLocation] = useState<UserLocation>({
    country: null,
    region: null,
    city: null,
    currency: null
  });
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [locationError, setLocationError] = useState<string | null>(null);

  const detectUserLocation = async () => {
    setIsLoadingLocation(true);
    setLocationError(null);
    
    try {
      console.log("Fetching user location from IP...");
      const location = await getUserLocationFromIP();
      
      if (location.country) {
        const currency = getDefaultCurrencyForCountry(location.country);
        
        const locationData = {
          country: location.country,
          region: location.region || null,
          city: location.city || null,
          currency: currency
        };
        
        console.log("Location detected:", locationData);
        setUserLocation(locationData);
      } else {
        setLocationError("Could not detect your location. Please select it manually.");
        // Default to USD if location can't be detected
        setUserLocation({
          country: null,
          region: null,
          city: null,
          currency: "USD"
        });
      }
    } catch (error) {
      console.error("Error detecting location:", error);
      setLocationError("Error detecting your location. Please select it manually.");
      // Default to USD on error
      setUserLocation({
        country: null,
        region: null,
        city: null,
        currency: "USD"
      });
    } finally {
      setIsLoadingLocation(false);
    }
  };

  useEffect(() => {
    detectUserLocation();
  }, []);

  return {
    userLocation,
    setUserLocation,
    isLoadingLocation,
    locationError,
    detectUserLocation
  };
};
